import { useIntl } from "react-intl";

import TabsContent from "@/components/adg4/tabs-content/src/tabs-content";
import { useLocalizedHref } from "@/libraries/web-framework";
import { DataEventProps } from "@/libraries/wpl/foundations/src";

const DesignTabContent = () => {
    const intl = useIntl();

    const cardCtaText = intl.formatMessage({
        id: "HomePageTemplateV2.tab.design.card.linkText",
        defaultMessage: "Try it out"
    });

    const cardDataEventProps: DataEventProps = {
        "data-product-key": "home",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked",
        "data-label": cardCtaText,
        "data-label-english": "Try it out"
    };
    const cardOneCtaUrl = useLocalizedHref(
        "/software/jira/templates/web-design-process"
    );
    const cardTwoCtaUrl = useLocalizedHref(
        "/software/confluence/templates/design-system"
    );
    const cardThreeCtaUrl = useLocalizedHref(
        "/software/confluence/templates/design-decision"
    );

    return (
        <TabsContent
            className="homepage-tabs-content"
            contentList={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.design.header",
                        defaultMessage: "Design with all the right context"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.design.bodytext",
                        defaultMessage:
                            "Organize work, synchronize teams, and meet deadlines – all without sacrificing creativity"
                    })
                }
            ]}
            pictureProps={{
                image: {
                    src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/design-main.webp",
                    alt: "",
                    height: 400,
                    width: 768
                }
            }}
            tabContentEyebrowText={intl.formatMessage({
                id: "HomePageTemplateV2.tab.design.resources",
                defaultMessage: "Get started with a template"
            })}
            cardsContent={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.design.card1.headerText",
                        defaultMessage: "Web design process"
                    }),
                    headerType: "h5",
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.design.card1.bodyText",
                        defaultMessage:
                            "Keep designers and developers on the same page"
                    }),
                    clickableCardUrl: cardOneCtaUrl,
                    ctaProps: {
                        primaryLinkProps: {
                            text: cardCtaText,
                            type: "basic",
                            href: cardOneCtaUrl,
                            doesArrowAnimate: true,
                            dataEventProps: cardDataEventProps
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/design-card-1.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.design.card2.headerText",
                        defaultMessage: "Design system"
                    }),
                    headerType: "h5",
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.design.card2.bodyText",
                        defaultMessage:
                            "Scale your design team by developing a unified design system"
                    }),
                    clickableCardUrl: cardTwoCtaUrl,
                    ctaProps: {
                        primaryLinkProps: {
                            text: cardCtaText,
                            type: "basic",
                            href: cardTwoCtaUrl,
                            doesArrowAnimate: true,
                            dataEventProps: cardDataEventProps
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/design-card-2.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.design.card3.headerText",
                        defaultMessage: "Design decisions"
                    }),
                    headerType: "h5",
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.design.card3.bodyText",
                        defaultMessage:
                            "Present design solutions and exchange creative feedback with your team"
                    }),
                    clickableCardUrl: cardThreeCtaUrl,
                    ctaProps: {
                        primaryLinkProps: {
                            text: cardCtaText,
                            type: "basic",
                            href: cardThreeCtaUrl,
                            doesArrowAnimate: true,
                            dataEventProps: cardDataEventProps
                        }
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/design-card-3.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                }
            ]}
        />
    );
};

export { DesignTabContent };
